import { RT_API_DEMO } from 'src/store/ActionTypes';

/**
 * submitDemoRequest - submit demo request
 * @param {DemoPayload} payload
 * @returns {{payload: DemoPayload, type: string}}
 */
export const submitDemoRequest = (payload) => ({
  type: RT_API_DEMO.SUBMIT_DEMO,
  payload,
});

/**
 * fetchConfig - Fetch a realtime API config by ID
 * @param payload {string} - config ID
 * @returns {{payload: string, type: string}}
 */
export const fetchConfig = (payload) => ({
  type: RT_API_DEMO.FETCH_CONFIG,
  payload,
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: RT_API_DEMO.UNSET,
  payload: key,
});
